// @ts-strict-ignore
import type { Outcome, Tag } from 'flow/store/engine/types';
import { DEFAULT_OUTCOME_COLOR_IN_HEX_FORMAT, DEFAULT_OUTCOME_ICON_NAME } from 'flow/editor/components/constants';

export function getOutcomeByName(outcomes: Outcome[], outcomeName: string): Outcome {
  return outcomes.find(outcome => outcome.outcome === outcomeName);
}

export function getActiveOutcomes(outcomes: Outcome[]): Outcome[] {
  return outcomes.filter(outcome => !outcome.archived && !outcome.is_event_status);
}

export function createEphemeralOutcome(overrides: {
  color?: Outcome['outcome_color'];
  isCaseStatus?: Outcome['is_case_status'];
  isEventStatus?: Outcome['is_event_status'];
  name: Outcome['outcome'];
}): Outcome {
  return {
    archived: false,
    customer_id: null,
    customer_outcome_id: null,
    icon_name: DEFAULT_OUTCOME_ICON_NAME,
    is_case_status: overrides.isCaseStatus ?? false,
    is_ephemeral: true,
    is_event_status: overrides.isEventStatus ?? false,
    is_federated: false,
    outcome_color: overrides.color ?? DEFAULT_OUTCOME_COLOR_IN_HEX_FORMAT,
    outcome: overrides.name ?? '',
  };
}

export function isOutcomeEphemeral(outcome: Outcome | Tag['outcomes'][number]): boolean {
  if (!outcome) return false;
  return Boolean(outcome.is_ephemeral);
}

export function indexOutcomesByName(outcomes: Outcome[]): Record<Outcome['outcome'], Outcome> {
  return Object.fromEntries(
    outcomes.map(outcome => [outcome.outcome, outcome]),
  );
}
